import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PdfViewerV2 from "../../../components/PdfViewerV2";
import PdfViewer from "../../../components/PdfViewer";

const PackingListDialog = ({ open, handleClose, dataUrl }) => {
  return (
    <Dialog open={open} onClose={handleClose} fullScreen={true}>
      <>
        <DialogContent sx={{ padding: 0 }}>
          {dataUrl && (
            <Box sx={{ height: "100%", width: "100%" }}>
              <PdfViewerV2
                fileUri={dataUrl}
                downloadName={"PACKING_LIST.pdf"}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default PackingListDialog;
